var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCareer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 101,
    viewBox: "0 0 91 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_519_140",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0478 0.00292969H0.00646973V100.41H90.0478V0.00292969Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_519_140)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8113 76.935V96.0929C21.8113 98.476 19.8768 100.41 17.4936 100.41H4.3258C1.94262 100.41 0.00805664 98.476 0.00805664 96.0929V76.935C0.00805664 74.552 1.94262 72.6177 4.3258 72.6177H17.4936C19.8768 72.6177 21.8113 74.552 21.8113 76.935Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9922 65.626V96.067C55.9922 98.464 54.0462 100.41 51.6489 100.41H38.4031C36.0058 100.41 34.0598 98.464 34.0598 96.067V65.626C34.0598 63.229 36.0058 61.283 38.4031 61.283H51.6489C54.0462 61.283 55.9922 63.229 55.9922 65.626Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0485 51.9012V96.093C90.0485 98.4763 88.114 100.41 85.7308 100.41H72.563C70.1798 100.41 68.2452 98.4763 68.2452 96.093V51.9012C68.2452 49.518 70.1798 47.5837 72.563 47.5837H85.7308C88.114 47.5837 90.0485 49.518 90.0485 51.9012Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7504 25.0919C48.8454 43.023 31.0959 49.4423 19.6541 52.6581C15.3611 53.8647 9.45417 54.8528 6.06947 49.8278C3.13782 45.4746 7.48847 42.0047 8.65204 41.255C12.5226 38.7661 37.7357 30.0801 57.257 10.7983C53.7876 8.24507 49.8235 5.76169 46.6018 3.84873C45.8698 3.38378 45.5321 2.49374 45.7707 1.66111C46.0103 0.827724 46.7694 0.252695 47.6355 0.246113C58.0264 0.165177 76.5166 0.0479409 83.0806 0.00527476C83.6587 0.00108777 84.2068 0.263639 84.5676 0.714135C84.9296 1.16599 85.0636 1.75774 84.9317 2.32106L77.0065 36.4149C76.8101 37.2588 76.0831 37.8732 75.2193 37.9291C74.3545 37.9837 73.5552 37.4672 73.2522 36.6545C72.0889 33.2315 70.5202 28.9786 68.7504 25.0919Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCareer);
export default __webpack_public_path__ + "static/media/icon_career.7e7d6ff6bd23fdbd709f67fc121773b7.svg";
export { ForwardRef as ReactComponent };